// Privacy policy. Plain-language; cross-references the Transparency
// page for the data-by-data breakdown.

import { LegalLayout } from "./LegalLayout";

export function PrivacyPage() {
  return (
    <LegalLayout
      title="Privacy"
      revisedAt="May 24, 2026"
      current="privacy"
    >
      <p>
        Link is a chat and workspace product. We try to do the
        normal product things — store your messages, deliver them
        to your friends, search them later — while collecting as
        little about you as we can.
      </p>

      <h2>Identity</h2>
      <p>
        You sign up with a 12-word recovery phrase generated on
        your device. We never see the phrase, and we can't recover
        your account if you lose it. The cryptographic public key
        derived from the phrase is the only identity-bearing thing
        we store.
      </p>

      <h2>What we know about you</h2>
      <p>
        See the <a href="/transparency">Transparency page</a> for
        the exhaustive list. The short version: account hash,
        public key, the display name and avatar you chose, and the
        rooms / messages / files you sent through us.
      </p>

      <h2>What you control</h2>
      <ul>
        <li>
          <strong>Export.</strong> Settings → Data &amp; Privacy →
          Request export. We produce a JSON archive within 24
          hours.
        </li>
        <li>
          <strong>Delete.</strong> Same panel. 7-day grace window;
          after that everything except a small account-hash
          tombstone is gone.
        </li>
        <li>
          <strong>Block.</strong> Any other account, from their
          profile card. Blocks are total: no DMs, no friend
          requests, no space invites in either direction.
        </li>
      </ul>

      <h2>Third parties</h2>
      <p>
        We use Sentry for crash reporting and Axiom for server
        logs. Both transports apply a deny-list scrubber that
        strips message bodies, key material, recovery seeds, and
        encryption envelopes before any log line leaves our
        servers.
      </p>
      <p>
        If you connect an AI provider (OpenAI, Anthropic, Ollama)
        in Settings → AI, your prompts go directly from your
        browser to that provider's endpoint. We are not on the
        path. We cannot see, log, or replay those prompts.
      </p>

      <h2>Cookies</h2>
      <p>
        We use one session cookie to keep you signed in. No
        analytics cookies, no advertising cookies, no tracking
        cookies.
      </p>

      <h2>Children</h2>
      <p>
        Link isn't designed for anyone under 13. If we learn that
        an account belongs to someone under 13 we will close it.
      </p>

      <h2>Changes</h2>
      <p>
        Material changes to this policy land in the changelog at
        the bottom of the Transparency page and reset the "last
        revised" date above.
      </p>
    </LegalLayout>
  );
}
